import {api, basicAuthHeader} from "./axiosConfig";
import Env from "../env";

interface DataApi {
  categories: () => Promise<APISection>;
  findByCategory: (category: string) => Promise<APIResponse>;
  findById: (id: number) => Promise<APIResponse>;
  getArticles: () => Promise<APIResponse>;
  getNaviInfos: (naviId: string) => Promise<APIResponse>;
  search: (data: string) => Promise<any>;
  verifyCaptcha: (token: string) => Promise<any>;
  searchByDevice: (search: string) => Promise<any>;
  searchByEmail: (search: string) => Promise<any>;
  changeBetaTesteur: (user_id: number, testeur: boolean) => Promise<any>;
  searchUserBetaTesteur: (email: string) => Promise<any>;
  createSavSession: (
    login: string,
    password: string
  ) => Promise<{token: string; expires_at: number}>;
}

const URL_FAQ = "/faq";

const DataAPI: DataApi = {
  categories: async () => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/categories`,
      method: "GET",
    });
    return response.data;
  },

  findByCategory: async (category: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/articles/category/${category}`,
      method: "GET",
    });
    return response.data;
  },

  findById: async (id: number) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/articles/category/${id}`,
      method: "GET",
    });
    return response.data;
  },

  getArticles: async () => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/articles/titles`,
      method: "GET",
    });
    return response.data;
  },

  getNaviInfos: async (naviId: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/console/infos/${naviId}`,
      method: "GET",
    });
    return response.data;
  },

  search: async (data: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/articles/search`,
      method: "POST",
      data: {criteria: data},
    });
    return response.data;
  },

  verifyCaptcha: async (token: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `${URL_FAQ}/verify/captcha`,
      method: "POST",
      data: {token: token},
    });
    return response.data;
  },

  searchByDevice: async (search: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/user/search/device/${search}`,
      method: "GET",
    });
    return response.data;
  },

  searchByEmail: async (search: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/user/search/email/${search}`,
      method: "GET",
    });
    return response.data;
  },

  changeBetaTesteur: async (user_id: number, testeur: boolean) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/tester`,
      method: "POST",
      data: {user_id: user_id, testeur: testeur},
    });
    return response.data;
  },

  searchUserBetaTesteur: async (id: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/beta-testeur`,
      method: "POST",
      data: {device_id: id},
    });
    return response.data;
  },

  // Échange le login SAV contre un jeton de session de 12 h (seul appel qui envoie le mot de passe).
  createSavSession: async (login: string, password: string) => {
    const response = await api.request({
      baseURL: Env.API_URL,
      url: `/sav/session`,
      method: "GET",
      headers: {Authorization: basicAuthHeader(login, password)},
    });
    return response.data;
  },
};

export default DataAPI;
